import Vue from 'vue'
import ProductContainer from '@/product/components/ProductContainer.vue'
import TopRecommendations from '@/product/components/TopRecommendations.vue'
import store from '@/product/store'
import router from '@/product/router'
import { formatCurrencyJP } from '@/common/filter'
import { app } from '@/product/selectors'
//@ts-ignore
import VCalendar from 'v-calendar'
import './main.entry.scss'

const init = (mountDistribution: string) => {
  if (!document.querySelector(mountDistribution)) {
    return false
  }
  const isMobileLayout = window.innerWidth < 1024

  Vue.filter('formatCurrencyJP', formatCurrencyJP)

  Vue.use(VCalendar)

  new Vue({
    store,
    router,
    render: h => h(ProductContainer, { props: {
      isMobileLayout: isMobileLayout
    }})
  }).$mount(mountDistribution)
}

const initTopRecommendations = (topRecommendationsMountEl: string) => {
  if (!document.querySelector(topRecommendationsMountEl)) {
    return false
  }

  new Vue({
    store,
    router,
    render: h => h(TopRecommendations, { props: {}})
  }).$mount(topRecommendationsMountEl)
}

init(app.productMountEl)
initTopRecommendations(app.topRecommendationsMountEl)
